import { Icons } from "assets/icons";
import PageHeader from "components/common/PageHeader";
import DetailsShimmer from "components/common/shimmer/DetailsShimmer";
import { SentimentBadge } from "components/common/StatusBadge";
import InfoItem from "components/common/detailsPage/InfoItem";
import NoPermission from "components/common/NoPermission";
import { usePermission } from "hooks/usePermission";
import { useQueryParam } from "hooks/useQueryParam";
import React, { useEffect } from "react";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getRatingDetails } from "store/slices/ratingSlice";
import { ISSUE_TAG_OPTIONS } from "utils/constants";
import { formatUTCDate } from "utils/utils";

const RatingDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const dispatch = useDispatch();
  const id = useQueryParam("id");
  const { starBlack } = Icons || {};

  const { canAction } = usePermission();
  const { canView } = canAction("ratings");

  const { loading, itemDetails } = useSelector((state) => state.Ratings);

  const { rating: ratingData, customer, branch } = itemDetails || {};
  const { rating, sentiment, comment, issueTags, createdAt } = ratingData || {};

  useEffect(() => {
    if (id && canView) {
      dispatch(getRatingDetails(id));
    }
  }, [id, canView, dispatch]);

  const issueTagLabels = (issueTags || [])
    .map((tag) =>
      t(ISSUE_TAG_OPTIONS.find((o) => o.value === tag)?.name || tag),
    )
    .join(", ");

  const infoFields = [
    {
      label: t("Customer Name"),
      value: customer?.name,
      col: { lg: 3, md: 3, sm: 6, xs: 6 },
      classname: "rating_info_item",
    },
    {
      label: t("Phone Number"),
      render: <div className="ltr_text">{customer?.phone || "-"}</div>,
      col: { lg: 3, md: 3, sm: 6, xs: 6 },
      classname: "rating_info_item",
    },
    {
      label: t("Branch Name"),
      value:
        (language === "ar" ? branch?.name?.ar : branch?.name?.en) ||
        branch?.name ||
        "-",
      col: { lg: 3, md: 3, sm: 6, xs: 6 },
      classname: "rating_info_item",
    },
    {
      label: t("Rating"),
      render: (
        <div className="g_start gap-1">
          <img src={starBlack} width={16} height={16} alt="star" className="mt-1"/>
          <h6 className="value mb-0">{rating ?? "-"}</h6>
        </div>
      ),
      col: { lg: 3, md: 3, sm: 6, xs: 6 },
      classname: "rating_info_item",
    },
    { isSpacer: true },
    // {
    //   label: t("Sentiment"),
    //   render: <SentimentBadge sentiment={sentiment} t={t} />,
    //   col: { lg: 3, md: 3 },
    // },
    // {
    //   label: t("Issue Tags"),
    //   value: issueTagLabels || "-",
    //   col: { lg: 3, md: 3 },
    // },
    {
      label: t("Date"),
      value: createdAt ? formatUTCDate(createdAt) : "-",
      col: { lg: 3, md: 3, sm: 6, xs: 6 },
      classname: "rating_info_item",
    },
    { isSpacer: true },
    // {
    //   label: t("Comment"),
    //   value: comment || "-",
    //   col: { lg: 12, md: 12 },
    // },
  ];

  const shimmerLayout = [
    {
      col: 12,
      blocks: [
        { rows: 1, cols: 6 },
        { rows: 1, cols: 5 },
      ],
    },
    {
      col: 12,
      blocks: [{ rows: 1, cols: 3 }],
    },
  ];

  if (!canView) return <NoPermission />;

  if (loading) {
    return (
      <div className="page-content">
        <PageHeader
          title={t("Rating Details")}
          isBackBtn
          className="details_page_title"
        />
        <DetailsShimmer layout={shimmerLayout} />
      </div>
    );
  }

  return (
    <div className="page-content common_details_page rating_details_page">
      <PageHeader
        title={t("Rating Details")}
        isBackBtn
        className="details_page_title"
      />
      <div className="common_card">
        <h2 className="title_20 mb-4">{t("General Details")}</h2>
        <Row>
          {infoFields.map((item, index) => {
            if (item.isSpacer) {
              return <div key={index} className="mt-4 w-100" />;
            }

            return (
              <InfoItem
                key={index}
                label={item.label}
                value={item.value}
                col={item.col}
                classname={item.classname}
              >
                {item.render}
              </InfoItem>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default RatingDetails;
